import { Fragment } from "react";
import { JOURNEY_STEPS, journeyStep } from "~/lib/parcel-status";
import { cn } from "~/lib/utils";

export function ParcelProgress({ status, className }: { status?: string | null; className?: string }) {
  const current = journeyStep(status);
  const delivered = status === "DELIVERED";
  const held = status === "ON_HOLD";
  const reached = delivered ? "bg-success" : "bg-foreground";
  return (
    <div
      role="img"
      aria-label={`Step ${current + 1} of ${JOURNEY_STEPS.length}: ${JOURNEY_STEPS[current]}`}
      className={cn("flex items-center", className)}
    >
      {JOURNEY_STEPS.map((step, i) => (
        <Fragment key={step}>
          <span
            className={cn(
              "size-2 shrink-0 rounded-full",
              i === current && held ? "bg-warning" : i <= current ? reached : "bg-muted",
              i === current && !delivered && "ring-foreground/15 size-2.5 ring-4",
            )}
          />
          {i < JOURNEY_STEPS.length - 1 && <span className={cn("h-0.5 flex-1", i < current ? reached : "bg-muted")} />}
        </Fragment>
      ))}
    </div>
  );
}
